import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Scroll } from '@phosphor-icons/react';
import { DataTable, FilterBar, StatusBadge } from '../../components/admin/AdminComponents';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ACTION_COLORS = {
  'invitation.sent': '#00F0FF', 'invitation.accepted': '#10B981',
  'role.assigned': '#F59E0B', 'role.removed': '#EF4444',
  'user.status.changed': '#F59E0B', 'user.role.changed': '#3B82F6',
  'shop.verified': '#10B981', 'shop.unverified': '#EF4444',
  'publisher.verified': '#10B981', 'publisher.unverified': '#EF4444',
  'publisher.onboarded': '#3B82F6',
  'report.dismiss': '#555', 'report.warn': '#F59E0B', 'report.restrict': '#EF4444',
  'bulk.shops.verified': '#10B981', 'bulk.publishers.verified': '#10B981',
};

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (search) params.append('action_type', search);
      const { data } = await axios.get(`${API_URL}/api/admin-console/audit-logs?${params}`, { withCredentials: true });
      setLogs(data || []);
    } catch {} finally { setLoading(false); }
  };

  useEffect(() => { fetchLogs(); }, []);

  const columns = [
    {
      key: 'created_at', label: 'Timestamp',
      render: v => <span className="text-[11px] text-[#555] tabular-nums whitespace-nowrap">{v ? new Date(v).toLocaleString() : '—'}</span>,
    },
    {
      key: 'action', label: 'Action',
      render: v => (
        <span className="text-[11px] px-2 py-0.5 rounded-md font-medium whitespace-nowrap"
          style={{ backgroundColor: `${ACTION_COLORS[v] || '#555'}15`, color: ACTION_COLORS[v] || '#555' }}>
          {v}
        </span>
      ),
    },
    { key: 'summary', label: 'Summary', render: v => <span className="text-[12px] text-[#888]">{v}</span> },
    {
      key: 'actor_name', label: 'Actor', cellClass: 'hidden md:table-cell',
      render: (_, row) => (
        <div>
          <p className="text-[12px] text-[#999]">{row.actor_name}</p>
          <p className="text-[10px] text-[#333]">{row.actor_email}</p>
        </div>
      ),
    },
    {
      key: 'target_id', label: 'Target', cellClass: 'hidden lg:table-cell',
      render: v => <span className="text-[10px] text-[#333] font-mono">{v ? `${v.slice(0, 8)}...` : '—'}</span>,
    },
  ];

  return (
    <div data-testid="admin-audit-page">
      <div className="mb-5">
        <h1 className="text-xl font-bold text-white tracking-tight" style={{ fontFamily: 'Unbounded' }}>Audit Logs</h1>
        <p className="text-[13px] text-[#444] mt-0.5">System activity and change history</p>
      </div>

      <FilterBar searchValue={search} onSearchChange={setSearch} onSearch={fetchLogs}
        searchPlaceholder="Filter by action type..." count={logs.length} label="entries" />

      <DataTable columns={columns} data={logs} loading={loading} emptyMessage="No audit logs" emptyIcon={Scroll}
        rowTestIdPrefix="audit" />
    </div>
  );
}
